<template>
 <!-- :style="{'min-height': docHt-100 + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <h3 class="h3">基本信息认证</h3>
      <div class="section" v-if="shopNature == 'CS202206101028' || shopNature == 'CS202206101029'">
        <h5>营业执照上传</h5>
        <div class="upload-group">
          <VantUploadImg-License name="营业执照" :shopCode="inputForm.shopCode" :value="form.businessLicensePic" @valChange="getLicenseImg" />
        </div>
        <div class="input-group" v-if="form.businessLicensePic !== ''">
          <div class="input-row">
            <h5>名称</h5>
            <el-input v-model="inputForm.shopLicenseName" placeholder="请输入名称" @input="shopLicenseNameInput" @change="shopLicenseNameChange" maxlength="20"></el-input>
          </div>
          <div class="input-row">
            <h5>统一社会信用代码</h5>
            <el-input v-model="inputForm.shopLicense" placeholder="请输入统一社会信用代码" @input="shopLicenseInput" maxlength="30"></el-input>
          </div>
          <div class="input-row">
            <div class="error-msg" v-show="isVaildLicense && inputForm.shopLicense !== ''">统一社会信用代码格式不正确</div>
            <h5>有效期</h5>
            <div class="validity-box" v-if="isMobile">
              <div class="col" style="width:12.5rem;" @click="isShowLicense = true" v-if="inputForm.isLongLicense !== 1">
                <span class="date-time" v-if="inputForm.shopLicenseDeadline !== ''">{{inputForm.shopLicenseDeadline}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <div class="col col-valid-disable" v-else>
                <span class="date-time" v-if="inputForm.shopLicenseDeadline !== ''">{{inputForm.shopLicenseDeadline}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <el-checkbox v-model="inputForm.isLongLicense" :true-label="1" :false-label="0" class="is-long" @change="inputForm.shopLicenseDeadline = ''">长期</el-checkbox>
            </div>
            <div class="pc-validity-box" v-else>
              <el-date-picker class="col" style="width:6.5rem;"
                v-model="inputForm.shopLicenseDeadline"
                type="date"
                :clearable="false"
                placeholder="请选择有效期"
                format="yyyy-MM-dd"
                :disabled="inputForm.isLongLicense === 1 ? true : false">
              </el-date-picker>
              <el-checkbox v-model="inputForm.isLongLicense" :true-label="1" :false-label="0" class="is-long" @change="inputForm.shopLicenseDeadline = ''">长期</el-checkbox>
            </div>
            <VantDatetimePicker-License name="营业执照有效期" :showPopup="isShowLicense" @isShow="isShowLicense = false" @open="isShowLicense = true" @dateInput="licenseDateChange" />
          </div>
        </div>
      </div>
      <div class="section">
        <h5 v-if="shopNature == 'CS202206101028' || shopNature == 'CS202206101029'">法人证件上传</h5>
        <h5 v-else>负责人证件上传
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">如为身份证，请上传国徽面照片；<br/>如为港澳台通行证，请上传人像面反面照片；<br/>如为护照，再次上传人像面照片即可。</div>
            <img src="../assets/images/icon_doubt.png" class="icon-doubt" />
          </el-tooltip>
        </h5>
        <el-select v-model="form.papersType" placeholder="请选择" class="select-card" v-if="!isMobile">
          <el-option
            v-for="item in cardTypes"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="select-cont" @click="openCardType" v-else>
          <div class="select-cont-name" :class="papersTypeName==''?'select-cont-empty':''">{{papersTypeName!=''?papersTypeName:'请选择'}}</div>
        </div>
        <!-- 移动端-证件类型 -->
        <van-popup
          v-model="cardTypesShow"
          show="cardTypesShow"
          position="bottom"
          custom-style="height: 50%"
          get-container="body" 
          :lock-scroll="true"
          @close="cardTypesShow=false"
        >
          <van-picker
            show-toolbar
            :defaultIndex="idCardTypesIndex"
            :columns="cardTypes"
            @confirm="confirmPapersType"
            @cancel="cardTypesShow=false"
          >
            <template #option="cardTypes">
              {{ cardTypes.name }}
            </template>
          </van-picker>
        </van-popup>

        <div class="upload-group">
          <VantUploadImg-Front name="上传证件头像面" :shopCode="inputForm.shopCode" :value="form.idCardFrontPic" @valChange="getFrontImg" />
          <VantUploadImg-Back name="上传非头像面" :shopCode="inputForm.shopCode" :value="form.idCardBackPic" @valChange="getBackImg" />
        </div>
        <div class="input-group" v-if="form.idCardFrontPic !== '' && form.idCardBackPic !== ''">
          <div class="row">
            <span class="label-name">姓名</span>
            <el-input v-model="inputForm.lagelName" placeholder="请输入姓名" @input="inputLagelName" maxlength="20"></el-input>
          </div>
          <div class="row">
            <span class="label-name">证件号</span>
            <el-input v-model="inputForm.lagelIcard" placeholder="请输入证件号" @input="inputLagelIcard" maxlength="50"></el-input>
          </div>
          <div class="row">
            <span class="label-name">有效期</span>
            <div class="validity-box" v-if="isMobile">
              <div class="col" style="width:9rem;" @click="isShowIdCard = true" v-if="inputForm.isLongId !== 1">
                <span class="date-time" style="width:6rem;" v-if="inputForm.lagelVaildTime !== ''">{{inputForm.lagelVaildTime}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <div class="col" style="width:9rem;background:#f5f5f5;border-radius:10px 0 0 10px;" v-else>
                <span class="date-time" style="width:6rem;" v-if="inputForm.lagelVaildTime !== ''">{{inputForm.lagelVaildTime}}</span>
                <span class="date-placeholder" v-else>请选择有效期</span>
              </div>
              <el-checkbox v-model="inputForm.isLongId" :true-label="1" :false-label="0" class="is-long" @change="inputForm.lagelVaildTime = ''">长期</el-checkbox>
            </div>
            <div class="pc-validity-box" v-else>
              <el-date-picker class="col" style="width:4.6rem;"
                v-model="inputForm.lagelVaildTime"
                type="date"
                :clearable="false"
                placeholder="请选择有效期"
                format="yyyy-MM-dd"
                :disabled="inputForm.isLongId === 1 ? true : false">
              </el-date-picker>
              <el-checkbox v-model="inputForm.isLongId" :true-label="1" :false-label="0" @change="inputForm.lagelVaildTime = ''">长期</el-checkbox>
            </div>
          </div>
          <VantDatetimePicker-IdCard name="营业执照有效期" :showPopup="isShowIdCard" @isShow="isShowIdCard = false" @open="isShowIdCard = true" @dateInput="idCardDateChange" />
        </div>
      </div>
      <!-- 公司 -->
      <div class="section" v-if="shopNature == 'CS202206101028' || shopNature == 'CS202206101029'">
        <h5>法人联系方式</h5>
        <div class="upload-group">
          <el-input v-model="form.yeepayTel" placeholder="请输入联系方式" @input="yeepayTelInput" maxlength="13"></el-input>
        </div>
        <div class="error-msg" v-if="!isVaildYeepayTel && form.yeepayTel">请输入正确的手机号</div>
        <!-- <h5 style="margin-top:10px;">法人手持“营业执照”图片</h5>
        <VantUploadImg-BusinessLicense name="手持营业执照" :shopCode="inputForm.shopCode" :value="form.businessLicensePicHold" @valChange="getBusinessLicenseImg" /> -->
      </div>
      <!-- isCredentials 是否必传资质 0 否 1 是 -->
      <div class="section supplement-section" v-if="this.isCredentials == 1">
        <h5>资质上传<span v-if="credentialsDesc && credentialsDesc !== ''">（{{credentialsDesc}}）</span></h5>
        <VantUploadImg-Qualifi name="资质照片" :shopCode="inputForm.shopCode" :value="supplementImage" :limit="5" @valChange="getQualifiImg" />
      </div>
      <!-- 只有个体户显示 -->
      <div class="section radio-group-section" v-if="shopNature == 'CS202206101029'">
        <div class="radio-group">
          <van-radio-group v-model="yeePayBankTypeCode" direction="horizontal" @change="bankTypeChange">
            <van-radio :name="0" checked-color="#47B6C7" icon-size="1rem">对公账户</van-radio>
            <van-radio :name="1" checked-color="#47B6C7" icon-size="1rem">法人个人银行卡</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="section">
        <h5 v-if="yeePayBankTypeCode == 0 || shopNature == 'CS202206101028'">请上传开户许可证照片。开户名称必须与营业执照的名称保持一致。</h5>
        <h5 v-else>收款银行卡上传（注意：银行卡开户名必须和负责人姓名一致）</h5>
        <VantUploadImg-AccountCard name="开户许可证照片" :shopCode="inputForm.shopCode" :value="form.openAccountLicenceUrl" @valChange="getAccountCardImg" v-if="shopNature == 'CS202206101028' || yeePayBankTypeCode == 0"/>
        <VantUploadImg-BankCard name="银行卡照片" :shopCode="inputForm.shopCode" :value="form.bankCardPic" @valChange="getBankCardImg" v-else />
        <div class="input-group">
          <div class="row">
            <span class="label-name">开户名</span>
            <el-input v-model="form.bankUserName" placeholder="请输入开户名" @input="form.bankUserName = trimSpecial(form.bankUserName)" maxlength="20"></el-input>
          </div>
          <div class="row">
            <span class="label-name">开户账号</span>
            <el-input v-model="form.bankCardNo" placeholder="请输入开户账号"  @input="form.bankCardNo = checkNumAndLetters(form.bankCardNo)" maxlength="30"></el-input>
          </div>
          <div class="row">
            <span class="label-name">开户行</span>
            <el-select class="bank-select-box" v-if="!isMobile"
              v-model="form.bankCode"
              filterable
              remote
              reserve-keyword
              no-match-text="''"
              placeholder="请输入开户行"
              :remote-method="remoteMethod"
              :loading="loading">
              <el-option
                v-for="item in bankList"
                :key="item.id"
                :label="item.propertyName"
                :value="item.propertyKey">
              </el-option>
            </el-select>
            <!-- <el-select v-model="form.bankCode" filterable placeholder="请选择开户行" class="bank-select-box">
              <el-option 
                v-for="item in bankList"
                :key="item.id"
                :label="item.propertyName"
                :value="item.propertyKey">
              </el-option>
            </el-select> -->
            <div class="select-cont" style="margin-bottom: 0;" @click="openBankCardType" v-else>
              <div class="select-cont-name" :class="bankCardName==''?'select-cont-empty':''">{{bankCardName!=''?bankCardName:'请选择开户行'}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 移动端-银行卡类型 -->
      <van-popup v-model="bankTypesShow" get-container="body" :lock-scroll="true" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
        <div class="bank-modal">
          <div class="m-header">
            选择开户行
          </div>
          <div class="m-body">
            <el-input v-model="queryBankName" placeholder="请输入开户行" maxlength="30" @input="remoteMethod" class="input"></el-input>
            <ul class="infinite-list" style="overflow:auto">
              <li v-for="item,index in bankList" :key="index" class="infinite-list-item" :class="form.bankCode==item.propertyKey?'item-active':''" @click="cBank(item)">
                <div class="bank-name">{{item.propertyName }}</div>
                <span class="icon iconfont" :class="form.bankCode==item.propertyKey?'icon-agree':'icon-a-noSelected'"></span>
              </li>
            </ul>
          </div>
        </div>
      </van-popup>

      <div class="section agreement-section">
        <span class="iconfont" :class="isRead ? 'icon-agree' : 'icon-a-noSelected'" @click="toReadAgreement"></span>
        <p class="agreement-info">
          我已阅读并同意
          《<span class="licence" @click="openCprAgreement">商家用户协议</span>》
          《<span class="licence" @click="openPrivacyAgreement">隐私协议</span>》，支付收付款监管体系由易宝支付提供，查看《<span class="licence" @click="toPreviewImg">中华人民共和国支付业务许可证</span>》</p>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer" style="z-index: 999;">
      <div class="btn-group">
        <div class="btn prev-btn" @click="goBack">上一步</div>
        <template v-if="shopNature == 'CS202206101030'">
          <!-- || !this.form.businessLicensePicHold   || !form.yeepayTel -->
          <!-- <div class="btn confim-btn disabled-btn" v-if="!form.idCardFrontPic || !form.idCardBackPic || !form.bankCardPic || !isRead">提交</div> -->
          <div class="btn confim-btn" @click="onSubmit">提交</div>
        </template>
        <template v-else>
          <!-- <div class="btn confim-btn disabled-btn" v-if="!form.businessLicensePic || !form.idCardFrontPic || !form.idCardBackPic || !form.yeepayTel || !isVaildYeepayTel ||  !isRead">提交</div> -->
          <div class="btn confim-btn" @click="onSubmit">提交</div>
        </template>
        <router-link :to="{ path: '/apply-results?shopCode=' + shopCode}" class="jump-btn">跳过</router-link>
      </div>
    </div>
    <ContactBtn />

    <van-popup v-model="isShowCpr" get-container="body" :lock-scroll="true" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
      <div class="agreement-modal">
        <div class="m-header">
          <h3>商家用户协议</h3>
        </div>
        <div class="m-body ql-editor" v-html="cooperationAgreement"></div>
      </div>
    </van-popup>
    <van-popup v-model="isShowPrivacy" get-container="body" :lock-scroll="true" closeable close-icon="close" @close="closePopup" @click-overlay="closePopup" @click-close-icon="closePopup" position="bottom" class="popup">
      <div class="agreement-modal">
        <div class="m-header">
          <h3>隐私协议</h3>
        </div>
        <div class="m-body ql-editor" v-html="privacyAgreement"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ImagePreview, Picker, Popup } from 'vant';
import VantUploadImg from '@/components/VantUploadImg.vue';
import VantDatetimePicker from '@/components/VantDatePicker.vue';
import { validPhone, validStrAndNum } from '@/utils/validate';
import { getPropertyByPar, updateShopAuth, licenseOcrAuth, bankcardOcrAuth, idcardOcrAuth } from '@/api/auth';
import { getCategory, getPropertyList, getShopBasicInfo, contract }  from '@/api/baseinfo';
// import { bankList } from '@/utils/bankList.js';
import bankJson from '@/assets/json/bankList.json';
export default {
  name: 'baseinfo-auth',
  components: {
    'VantUploadImg-License': VantUploadImg,
    'VantUploadImg-Front': VantUploadImg,
    'VantUploadImg-Back': VantUploadImg,
    'VantUploadImg-BankCard': VantUploadImg,
    'VantUploadImg-Qualifi': VantUploadImg,
    'VantUploadImg-BusinessLicense': VantUploadImg,
    'VantUploadImg-AccountCard': VantUploadImg,
    'VantDatetimePicker-License': VantDatetimePicker,
    'VantDatetimePicker-IdCard': VantDatetimePicker,
  },
  data() {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      cooperationAgreement:'',
      privacyAgreement:'',
      shopCode: undefined,
      isMobile: false,
      isVaildLicense: false,
      isVaildYeepayTel: false,
      isRead: false,
      isShowCpr: false,
      isShowPrivacy: false,
      isShowLicense: false,
      isShowIdCard: false,
      isCredentials: undefined,
      credentialsDesc: undefined,
      shopNature: undefined, // 0 企业 1 个体户 2 个人 // CS202206101028 企业  CS202206101029 个体户  CS202206101030 个人
      supplementImage: '',
      yeePayBankTypeCode: 1,
      imgUrl: '',
      form: {
        businessLicensePic: '',
        merchantCode: undefined,
        idCardFrontPic: '',
        idCardBackPic: '',
        bankCardPic: '',
        businessLicensePicHold: '',
        openAccountLicenceUrl: '',
        yeepayTel: undefined,
        supplementImage: undefined,
        bankUserName: '',
        bankCardNo: '',
        bankCode: '',
        papersType: 1
      },
      inputForm: {
        shopLicense: '',
        shopLicenseName: '',
        shopLicenseDeadline: '',
        isLongId: 0,       // 身份证
        isLongLicense: 0,   // 营业执照
        lagelName: '',
        lagelIcard: '',
        lagelVaildTime: '',
      },
      papersTypeName: '',
      bankCardName: '',
      cardTypesShow: false,
      bankTypesShow: false,
      idCardTypesIndex: null,
      cardTypes: [{
        name: '身份证',
        value: 1,
        key: 'ID_CARD'
      },{
        name: '护照',
        value: 0,
        key: 'PASSPORT'
      },{
        name: '港澳居民往来内地通行证',
        value: 2,
        key: 'HM_VISITORPASS'
      },{
        name: '台胞证',
        value: 3,
        key: 'TAIWAN'
      },{
        name: '士兵证',
        value: 4,
        key: 'SOLDIER'
      },{
        name: '军官证',
        value: 5,
        key: 'OFFICERS'
      }],
      isRepeat: false,
      loading: false,
      bankList: [],
      queryBankName:'',
    };
  },
  created() {
    let authInfo = JSON.parse(sessionStorage.getItem('authInfo'));
    let authInputInfo = JSON.parse(sessionStorage.getItem('authInputInfo'));
    if(authInfo) {
      // this.supplementImage = authInfo.supplementImage[0] !== '' ? authInfo.supplementImage.join(',') : '';
      this.form = {
        businessLicensePic: authInfo.businessLicensePic,
        merchantCode: authInfo.merchantCode,
        idCardFrontPic: authInfo.idCardFrontPic,
        idCardBackPic: authInfo.idCardBackPic,
        bankCardPic: authInfo.bankCardPic,
        // businessLicensePicHold: authInfo.businessLicensePicHold,
        openAccountLicenceUrl: authInfo.openAccountLicenceUrl,
        yeepayTel: authInfo.yeepayTel,
        supplementImage: authInfo.supplementImage,
        bankUserName: authInfo.bankUserName,
        bankCardNo: authInfo.bankCardNo,
        bankCode: authInfo.bankCode,
        papersType: authInfo.papersType||1
      }
      let papersTypeArr = this.cardTypes.filter(v=>{return v.value==authInfo.papersType})||[];
      this.papersTypeName = papersTypeArr.length>0?papersTypeArr[0].name:'';
      let cardIndex = this.cardTypes.findIndex(v=>{return v.value==authInfo.papersType});
      this.idCardTypesIndex = cardIndex!=-1?cardIndex:0;
      this.isVaildYeepayTel = validPhone(authInfo.yeepayTel);
      this.bankList = bankJson.filter(item => {
        return item.propertyKey.indexOf(this.form.bankCode) > -1;
      });
      this.bankCardName = this.bankList.length>0?this.bankList[0].propertyName:'';
      this.queryBankName = this.bankCardName;
    }else{
      // this.bankList = bankJson.slice(0, 50);
    }
    if(authInputInfo) {
      this.inputForm = {
        shopLicense: authInputInfo.shopLicense,
        shopLicenseName: authInputInfo.shopLicenseName,
        shopLicenseDeadline: authInputInfo.shopLicenseDeadline,
        lagelName: authInputInfo.lagelName,
        lagelIcard: authInputInfo.lagelIcard,
        lagelVaildTime: authInputInfo.lagelVaildTime
      }
    }
    if(this.$route.query && this.$route.query.shopCode){
      this.shopCode = this.$route.query.shopCode;
    }
    this.getPropertyByPar();
    this.getShopBasicInfo();
    this.getQualificationImg();
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
  },
  methods: {
    cBank(item){
      this.form.bankCode = item.propertyKey;
      this.bankCardName = item.propertyName;
      this.bankTypesShow = false;
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        // this.form.bankCode = null;
        setTimeout(() => {
          this.loading = false;
          this.bankList = bankJson.filter(item => {
            return item.propertyName.indexOf(query) > -1;
          });
          this.bankList = this.bankList.slice(0, 50);
        }, 200);
      } else {
        if(this.form.bankCode){
          this.bankList = bankJson.filter(item => {
            return item.propertyKey.indexOf(this.form.bankCode) > -1;
          });
          this.bankList = this.bankList.slice(0, 50);
        }else{
          this.bankList = bankJson.slice(0, 50);
        }
      }
    },
    bankTypeChange() {
      this.form.bankUserName = this.shopNature==='CS202206101029'&&this.yeePayBankTypeCode===0?this.inputForm.shopLicenseName:null;
    },
    toPreviewImg() {
      if(!this.imgUrl) return this.Toast('支付业务资质图片加载失败，请稍后再试~');
      ImagePreview({
        images: this.imgUrl ? [this.imgUrl] : [],
        closeable: true	
      })
    },
    getQualificationImg() {
      getCategory('CS20220610102').then(res => {
        if(res.data && res.data.length > 0) {
          this.imgUrl = res.data[0].constantImg;
        }
      })
    },
    shopLicenseInput(val) {
      val = this.checkNumAndLetters(val);
      if(!validStrAndNum(val)) {
        this.isVaildLicense = true;
        this.inputForm.shopLicense = val;
        return 
      } else {
        this.isVaildLicense = false;
        this.inputForm.shopLicense = val.toString().toUpperCase();
      }
    },
    licenseDateChange(val) {
      this.inputForm.shopLicenseDeadline = val;
    },
    idCardDateChange(val) {
      this.inputForm.lagelVaildTime = val;
    },
    yeepayTelInput(value) {
      value = this.checkNumber(value);
      this.form.yeepayTel = value;
      this.isVaildYeepayTel = validPhone(value);
    },
    shopLicenseNameInput(val){
      val = this.trimSpecial(val);
      this.inputForm.shopLicenseName = val;
    },
    shopLicenseNameChange(val) {
      this.form.bankUserName = this.shopNature==='CS202206101028'||(this.shopNature==='CS202206101029'&&this.yeePayBankTypeCode===0)?val:null;
    },
    goBack() {
      this.$router.go(-1);
    },
    toReadAgreement() {
      this.isRead = !this.isRead;
    },
    openCprAgreement() {
      if(this.cooperationAgreement){
        this.isShowCpr = true;
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'auto';
      }else{
        contract('CS20220613110696').then(res => {
          if(res.data.articleJson){
            let data = res.data;
            let articleJson = JSON.parse(data.articleJson);
            this.cooperationAgreement = articleJson.AT;
            this.isShowCpr = true;
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'auto';
          }
        })
      }
    },
    openPrivacyAgreement() {
      if(this.privacyAgreement){
        this.isShowPrivacy = true;
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'auto';
      }else{
        contract('CS20220613110705').then(res => {
          if(res.data.articleJson){
            let data = res.data;
            let articleJson = JSON.parse(data.articleJson);
            this.privacyAgreement = articleJson.AT;
            this.isShowPrivacy = true;
            document.body.style.position = 'fixed';
            document.body.style.overflow = 'auto';
          }
        })
      }
    },
    closePopup() {
      document.body.style.position = '';
      this.isShowCpr=false;
      this.isShowPrivacy=false; 
      this.queryBankName = this.bankCardName?this.queryBankName:'';
    },
    getLicenseImg(val) {
      if(val == '') {
        this.form.bankUserName = this.shopNature==='CS202206101028'||(this.shopNature==='CS202206101029'&&this.yeePayBankTypeCode===0)?'':null;
        this.form.businessLicensePic = '';
        this.inputForm = {
          shopLicense: '',
          shopLicenseName: '',
          shopLicenseDeadline: '',
          lagelVaildTime: '',
          isLongId: 0,       // 身份证
          isLongLicense: 0   // 营业执照
        }
        return false;
      }
      this.form.businessLicensePic = val;
      // if(this.inputForm.shopLicenseName == '' || this.inputForm.shopLicense == '' || this.inputForm.shopLicenseDeadline == '' ) {}
        licenseOcrAuth(val).then(res => {
            let data = JSON.parse(res.msg)
            if(data.ENTERPRISE_ID == '') {
              this.Toast(data.ENTERPRISE_BUSINESS_CARD_OCR_STATUS)
            } else {
              let dateTime = data.ENTERPRISE_VALID_DATE_END;
              if(dateTime&&dateTime!==''&&dateTime!=='无') {
                let year = dateTime.substr(0,4);
                let month = dateTime.substr(5,2);
                let day = dateTime.substr(8,2);
                this.inputForm.shopLicenseDeadline = year+'-'+month+'-'+day;
              }
              this.inputForm.shopLicense = data.ENTERPRISE_ID;
              this.inputForm.shopLicenseName = data.ENTERPRISE_NAME_CH;
              this.form.bankUserName = this.shopNature==='CS202206101028'||(this.shopNature==='CS202206101029'&&this.yeePayBankTypeCode===0)?data.ENTERPRISE_NAME_CH:null;
              this.$forceUpdate();
            }
        })
    },
    openCardType(){
      this.cardTypesShow=true;
    },
    confirmPapersType(data){
      this.papersTypeName = data.name;
      this.form.papersType = data.value;
      let cardIndex = this.cardTypes.findIndex(v=>{return v.value==this.form.papersType});
      this.idCardTypesIndex = cardIndex!=-1?cardIndex:0;
      this.cardTypesShow = false;
    },
    openBankCardType(){
      this.bankTypesShow=true;
    },
    getFrontImg(val) {
      // this.form.idCardFrontPic = val;
      if(val == '') {
        this.form.idCardFrontPic = '';
        // this.inputForm = {
        //   lagelName: '',
        //   lagelIcard: '',
        //   lagelVaildTime: '',
        //   isLongId: 0,       // 身份证
        //   isLongLicense: 0   // 营业执照
        // }
        return false;
      }
      this.form.idCardFrontPic = val;
      this.inputForm.lagelName = '';
      this.inputForm.lagelIcard = '';
      // if(this.inputForm.lagelName == '' || this.inputForm.lagelIcard == '' || (this.inputForm.isLongId!==1&&this.inputForm.lagelVaildTime==='') ) {}
        idcardOcrAuth({url: val, side: 'front'}).then(res => {
            let data = res.data.words_result;
            if(res.code===200&&data) {
              this.inputForm.lagelName = data&&data['姓名']&&data['姓名'].words?data['姓名'].words:'';
              this.inputForm.lagelIcard = data&&data['公民身份号码']&&data['公民身份号码'].words?data['公民身份号码'].words:'';
              this.$forceUpdate();
            } else {
              this.Toast(res.msg)
            }
        })
      
    },
    getBackImg(val) {
      // this.form.idCardBackPic = val;
      if(val == '') {
        this.form.idCardBackPic = '';
        // this.inputForm = {
        //   lagelName: '',
        //   lagelIcard: '',
        //   lagelVaildTime: '',
        //   isLongId: 0,       // 身份证
        //   isLongLicense: 0   // 营业执照
        // }
        return false;
      }
      this.form.idCardBackPic = val;
      this.inputForm.lagelVaildTime = '';
      // if(this.inputForm.lagelName == '' || this.inputForm.lagelIcard == '' || (this.inputForm.isLongId!==1&&this.inputForm.lagelVaildTime==='') ) {}
        idcardOcrAuth({url: val, side: 'back'}).then(res => {
            let data = res.data.words_result;
            if(res.code===200&&data) {
              let dateTime = data&&data['失效日期']&&data['失效日期'].words?data['失效日期'].words:null;
              if(dateTime&&dateTime!=='') {
                let year = dateTime.substr(0,4);
                let month = dateTime.substr(4,2);
                let day = dateTime.substr(6,2);
                this.inputForm.lagelVaildTime = year+'-'+month+'-'+day;
                this.$forceUpdate();
              }
            } else {
              this.Toast(res.msg)
            }
        })
    },
    inputLagelName(e) {
      e = this.trimSpecial(e);
      this.$set(this.inputForm, 'lagelName', e);
    },
    inputLagelIcard(e) {
      e = this.trimSpecial(e);
      this.$set(this.inputForm, 'lagelIcard', e);
    },
    getBusinessLicenseImg(val) {
      this.form.businessLicensePicHold = val;
    },
    getQualifiImg(val) {
      this.supplementImage = val;
    },
    getBankCardImg(val) {
      if(val == '') {
        this.form.bankCardPic = '';
        return false;
      }
      this.form.bankCardPic = val;
      if((this.shopNature==='CS202206101029'&&this.yeePayBankTypeCode==0)||this.shopNature==='CS202206101028') return false;
      // if(this.form.bankUserName===''||this.form.bankCardNo===''||this.form.bankCode==='' ) {}
      bankcardOcrAuth({url: val}).then(res => {
          let data = res.data.result;
          if(res.code===200&&data) {
            this.form.bankUserName = data&&data.holder_name?data.holder_name:null;
            this.form.bankCardNo = data&&data.bank_card_number?data.bank_card_number:null;
            this.form.bankCode = data&&data.property_key?data.property_key:null;
            this.bankCardName = data&&data.bank_name?data.bank_name:'';
            this.queryBankName = this.bankCardName;
            if(!this.form.bankCode){
              this.bankList = bankJson.filter(item => {
                return item.propertyName.indexOf(this.bankCardName) > -1;
              })||[];
              this.form.bankCode = this.bankList.length>0?this.bankList[0].propertyKey:'';
            }
            this.$forceUpdate();
          } else {
            this.Toast(res.msg)
          }
      })
    },
    getAccountCardImg(val) {
      this.form.openAccountLicenceUrl = val;
    },
    getPropertyByPar() {
      getPropertyByPar(this.shopCode).then(res => {
        if(res.data) {
          this.isCredentials = res.data.isCredentials;
          this.credentialsDesc = res.data.credentialsDesc;
        }
      })
    },
    // getBankList() {
    //   getPropertyList('CS2022061038').then(res => {
    //     this.bankList = res.data;
    //   })
    // },
    getShopBasicInfo() {
      getShopBasicInfo(this.shopCode).then(res => {
        if(res.data) {
          this.shopNature = res.data.shopNature;
        }
      })
    },
    onSubmit() {
      let params = {};
      this.inputForm.shopLicenseDeadline = !this.isMobile ? this.parseTime(this.inputForm.shopLicenseDeadline, '{y}-{m}-{d}') : this.inputForm.shopLicenseDeadline;
      this.inputForm.lagelVaildTime = !this.isMobile ? this.parseTime(this.inputForm.lagelVaildTime, '{y}-{m}-{d}') : this.inputForm.lagelVaildTime;
      this.form.supplementImage = this.supplementImage !== '' ? this.supplementImage.split(',') : [];
      if(this.shopNature == 'CS202206101029') {
        this.form.yeePayBankTypeCode = this.yeePayBankTypeCode;
      } else {
        this.form.yeePayBankTypeCode = this.shopNature == 'CS202206101028' ? 0 : 1;
      }
      sessionStorage.setItem('authInfo', JSON.stringify(this.form));
      sessionStorage.setItem('authInputInfo', JSON.stringify(this.inputForm));
      if(this.shopNature == 'CS202206101030') {
        if(this.inputForm.isLongId != 1 && this.inputForm.lagelVaildTime === '') return this.Toast('请完善证件有效期~');
        if(!this.inputForm.lagelName || !this.inputForm.lagelIcard || !this.form.bankUserName || !this.form.bankCardNo || !this.form.bankCode) {
          return this.Toast('请完善信息~');
        }
      } else {
        if(this.inputForm.isLongLicense != 1 && this.inputForm.shopLicenseDeadline === '') return this.Toast('请完善营业执照有效期~');
        if(this.inputForm.isLongId != 1 && this.inputForm.lagelVaildTime === '') return this.Toast('请完善证件有效期~');
        if(this.inputForm.shopLicense == '' || this.isVaildLicense || this.inputForm.shopLicenseName == '' || !this.inputForm.lagelName || !this.inputForm.lagelIcard || !this.form.bankUserName || !this.form.bankCardNo || !this.form.bankCode) {
          return this.Toast('请完善信息~');
        }
      }
      if(this.yeePayBankTypeCode == 0 || this.shopNature == 'CS202206101028') {
        this.form.bankCardPic = '';
        if(this.form.openAccountLicenceUrl == '') return this.Toast('请上传开户许可证图片');
      }
      if(this.shopNature == 'CS202206101029' && this.yeePayBankTypeCode == 1) {
        this.form.openAccountLicenceUrl = '';
        if(this.form.bankCardPic == '') return this.Toast('请上传银行卡图片');
      }
      // if(this.inputForm.lagelIcard.length < 18) {
      //   return this.Toast('身份证号必须为18位');
      // }
      if(this.form.bankCardNo.length < 1) return this.Toast('请输入银行卡号');
      if(!this.form.idCardFrontPic) return this.Toast('请上传证件头像面');  // 请上传身份证头像面
      if(!this.form.idCardBackPic) return this.Toast('请上传非头像面');   // 请上传身份证国徽面
      if(this.shopNature=='CS202206101030'&&!this.form.bankCardPic) return this.Toast('请上传银行卡照片');
      if(this.shopNature!='CS202206101030'&&!this.form.businessLicensePic) return this.Toast('请上传营业执照');
      if(this.shopNature!='CS202206101030'&&!this.form.yeepayTel&&!this.isVaildYeepayTel) return this.Toast('请输入法人联系手机号/座机');
      if(!this.isRead) return this.Toast('请阅读并勾选协议');
      params = this.form;
      params.lagelIcard = this.inputForm.lagelIcard;
      params.lagelName = this.inputForm.lagelName;
      params.lagelVaildTime = this.inputForm.isLongId === 1 ? '9999-12-31' : this.inputForm.lagelVaildTime;
      params.shopLicense = this.inputForm.shopLicense;
      params.shopLicenseDeadline = this.inputForm.isLongLicense === 1 ? '9999-12-31' : this.inputForm.shopLicenseDeadline;
      params.shopLicenseName = this.inputForm.shopLicenseName;
      params.merchantCode = this.shopCode;
      params.isLongId = this.inputForm.isLongId;
      params.isLongLicense = this.inputForm.isLongLicense;
      // inputForm.shopLicenseDeadline inputForm.isLongLicense
      // inputForm.lagelVaildTime  inputForm.isLongId
      if(this.isRepeat) return false;
      this.isRepeat = true;
      updateShopAuth(params).then(res => {
        this.isRepeat = false;
        if(res.code == 200) {
          this.$router.push('/apply-results?shopCode=' + this.shopCode);
          sessionStorage.removeItem('authInfo');
          sessionStorage.removeItem('authInputInfo');
          sessionStorage.removeItem('annualFee');
          sessionStorage.removeItem('scaleFormInfo');
          sessionStorage.removeItem('scaleInfo');

        } else {
          return this.Toast(res.msg);
        }
      }).catch(err=>{
        this.isRepeat = false;
      })
      setTimeout(()=>{
        this.$router.push('/apply-results?shopCode=' + this.shopCode);
        sessionStorage.removeItem('authInfo');
        sessionStorage.removeItem('authInputInfo');
        sessionStorage.removeItem('annualFee');
        sessionStorage.removeItem('scaleFormInfo');
        sessionStorage.removeItem('scaleInfo');
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    .h3{
      width: 16.7rem;
      margin: .8rem auto 1.4rem;
      font-size: 1.2rem;
      color: #222222;
    }
  }
  .section{
    width: 16.7rem;
    margin: 0 auto 1.4rem;
    h5{
      margin-bottom: .4rem;
      font-size: .7rem;
      color: #666;
      font-weight: 400;
      display: flex;
      align-items: center;
      .icon-doubt{
        width: .8rem;
        margin-left: .2rem;
        cursor: pointer;
      }
    }
    .select-card{
      width: 100%;
      margin: .5rem 0;
      /deep/ .el-input__inner{
        border-radius: .5rem;
        font-size: .7rem;
        color: #222;
      }
    }
    .upload-group{
      @include flex(space-between);
      /deep/ .el-input__inner, /deep/ .el-textarea__inner{
        border-radius: .5rem;
        border: .05rem solid #ddd;
        font-size: .8rem;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
        font-size: .8rem;
      }
      /deep/ .el-input__inner{
        height: 2.4rem;
      }


      /deep/ .van-uploader__input-wrapper{
        width: 7.5rem;
        height: 7.5rem;
        @include flex();
        flex-direction: column;
      }
      .item{
        width: 7.5rem;
        height: 7.5rem;
        background: #F5F5F7;
        border-radius: .8rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .icon-add{
          font-size: 1.2rem;
          color: $base-color;
        }
        .txt{
          display: inline-block;
          font-size: .7rem;
          color: #999;
          margin-top: .3rem;
        }
      }
      .img-list{
        img{
          width: 7.5rem;
          height: 7.5rem;
          border-radius: .8rem;
        }
        .img-box{
          position: relative;
          .iconfont{
            font-size: 1.4rem;
            color: #222;
            position: absolute;
            right: .1rem;
            top: .1rem;
            z-index: 2;
          }
        }
      }
    }
    .input-group{
      margin-top: .5rem;
      .input-row{
        margin-bottom: .5rem;
      }
      .row{
        height: 2rem;
        @include flex-align();
        margin-bottom: .25rem;
        .label-name{
          width: 4.4rem;
          height: 2rem;
          line-height: 2rem;
          display: inline-block;
          margin-right: .25rem;
          font-size: .75rem;
          color: #222;
          text-align: left;
        }
      }
      /deep/ input, .validity-box{
        height: 2rem;
        // margin-bottom: .25rem;
        border-radius: .5rem;
        // border-radius: .5rem 0 0 .5rem;
        // border: .05rem solid #ddd;
        font-size: .8rem;
        color: #222;
        span{
          // width: 100%;
          height: 2rem;
          line-height: 2rem;
          padding: 0 15px;
          display: inline-block;
          font-size: .8rem;
        }
        .date-time{
          width: 16rem;
          color: #222;
        }
        .date-placeholder{
          width: calc(100% - 15px);
          display: inline-block;
          color: #ccc;
          padding-right: 0;
        }
      }
      .col-valid-disable{
        width:12.5rem;background:#f5f5f5;border-radius:.5rem 0 0 .5rem;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: .8rem;
        color: #ccc;
        font-weight: 400;
      }
      .validity-box, .pc-validity-box{
        width: 100%;
      }
      /deep/ .is-disabled{
      .el-input__inner{
          border: 10px 0 0 10px;
        }
      }
    }
  }
  .validity-box, .pc-validity-box{
    border: 1px solid #DCDFE6;
  }
  .pc-validity-box{
    border-radius:.5rem;
    /deep/ .el-input__inner{
      border: 0;
    }
  }
  .validity-box, .pc-validity-box{
    position: relative;
    /deep/ .el-checkbox{
      width: 4rem;
      height: 2rem;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #47B6C7;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background: #47B6C7;
      border-color: #47B6C7;
    }
  }
  .pc-validity-box{
    height: 2rem;
    /deep/ .el-checkbox__input, /deep/ .el-checkbox__inner{
      width: .8rem;
      height: .8rem;
    }
    /deep/ .el-checkbox__inner::after{
      height: 0.6rem;
      left: 0.35rem;
    }
    /deep/ .el-checkbox__label{
      line-height: 1;
      font-size: .7rem;
    }
    /deep/ .el-input__inner{
      margin-bottom: 0;
    }
  }
  .radio-group-section{
    width: 16.7rem;
    height: 3rem;
    margin-bottom: .65rem;
    .radio-group{
      height: 3rem;
      .van-radio-group{
        height: 3rem;
        .van-radio{
          font-size: .8rem;
          color: #222;
          &:first-child{
            margin-right: 1.8rem;
          }
        }
      }
    }
  }
  .bank-select-box{
    width: 16.65rem;
    height: 2rem;
    /deep/ .el-input{
      height: 2rem;
    }
    /deep/  .el-input__inner{
      height: 2rem;
      border-radius: .5rem;
      border: .05rem solid #DDDDDD;
      font-size: .8rem;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: .8rem;
      color: #ccc;
      font-weight: 400;
    }
  }
  .supplement-section{
    .upload-item{
      /deep/ .img-box{
        margin-bottom: 1rem;
      }
    }
  }
  .agreement-section{
    padding: .6rem .8rem;
    background: #F5F5F7;
    border-radius: .8rem;
    box-sizing: border-box;
    @include flex();
    .iconfont{
      font-size: 1rem;
      cursor: pointer;
    }
    .icon-a-noSelected{
      color: #ccc;
    }
    .icon-agree{
      color: $base-color;
    }
    .agreement-info{
      line-height: 1.5;
      margin-left: .6rem;
      font-size: .7rem;
      color: #0A1629;
      cursor: pointer;
      a{
        font-size: .7rem;
        color: #0A1629;
      }
      .licence{
        font-size: .7rem;
        color: $base-color;
      }
    }
  }

  .agreement-modal{
    width: 16.7rem;
    margin: 0 auto;
    padding-top: .05rem;
    padding-bottom: .75rem;
    .m-header{
      width: 16.7rem;
      margin: 0 auto;
      h3{
        font-size: .8rem;
        color: #222;
        margin: .75rem 0;
      }
    }
    .m-body{
      width: 16.7rem;
      max-height: 22.5rem;
      margin: 0 auto;
      overflow-y: auto;
      overflow-x: hidden;
      p{
        line-height: 1.5;
        font-size: .7rem;
        color: #333;
        margin-bottom: .6rem;
      }
    }
  }
  .error-msg{
    font-size: .65rem;
    color: #FF4743;
  }
  .footer{
    .btn-group{
      width: 16.2rem;
      .jump-btn{
        width: 3rem;
        font-size: .8rem;
        color: #47B6C7;
        text-align: right;
      }
    }
  }
  .select-cont{
    width: 16.7rem;
    height: 2rem;
    border: 1PX solid #ddd;
    border-radius: .5rem;
    padding: 0 15px;
    box-sizing: border-box;
    margin: 0 auto .5rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &-name{
      font-size: .8rem;
      color: #222;
    }
    &-empty{
      color: #c0c4cc;
    }
  }
  .bank-modal{
    width: 100%;
    .m-header{
      width: 90%;
      margin: 0 auto;
      line-height: 2.4rem;
      font-size: 0.8rem;
      color: #222;
      font-weight: bold;
    }
    .m-body{
      .input{
        width: 90%;
        margin: 0 5% .5rem;
      }
      .infinite-list{
        height: 25rem;
        overflow: auto;
        padding-bottom: 1rem;
        .infinite-list-item{
          line-height: 2.2rem;
          font-size: .7rem;
          color: #222;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 .5rem;
          .bank-name{
            font-size: .7rem;
            color: #222;
          }
          .icon{
            font-size: 1rem;
            color: #c0c4cc;
          }
          .icon-agree{
            color: #47B6C7;
          }
        }

      }
    }

  }
}
@media screen and (min-width:750px){
  
  .select-cont{
    width: 334px;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 0 15px;
    box-sizing: border-box;
    margin: 0 auto 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &-name{
      font-size: 16px;
      color: #222;
    }
    &-empty{
      color: #c0c4cc;
    }
  }
  /*
  .bank-modal{
    width: 500px;
    margin: 0 auto;
    .m-header{
      line-height: 44px;
      font-size: 16px;
      color: #222;
      font-weight: bold;
    }
    .m-body{
      .input{
        margin-bottom: 10px;
      }
      .infinite-list{
        height: 500px;
        overflow: auto;
        .infinite-list-item{
          line-height: 44px;
          font-size: 14px;
          color: #222;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px;
          .bank-name{
            font-size: 14px;
            color: #222;
          }
          .icon{
            font-size: 20px;
            color: #c0c4cc;
          }
          .icon-agree{
            color: #47B6C7;
          }
        }

      }
    }

  }
  */
  .wrapper{
    height: auto;
  }
  .container{
    height: 70vh;
    .h3{
      width: 334px;
      margin: 16px auto 28px;
      font-size: 24px;
      color: #222222;
    }
  }
  .section{
    width: 334px;
    margin: 0 auto 28px;
    h5{
      margin-bottom: 8px;
      font-size: 14px;
      color: #666;
      font-weight: 400;
      display: flex;
      align-items: center;
      .icon-doubt{
        width: 16px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
    .select-card{
      width: 100%;
      margin: 10px 0;
      /deep/ .el-input__inner{
        border-radius: 10px;
        font-size: 14px;
        color: #222;
      }
    }
    .upload-group{
      @include flex(space-between);
      /deep/ .el-input__inner, /deep/ .el-textarea__inner{
        border-radius: 10px;
        border: 1px solid #ddd;
        font-size: 16px;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
        font-size: 16px;
      }
      /deep/ .el-input__inner{
        height: 48px;
      }


      /deep/ .van-uploader__input-wrapper{
        width: 150px;
        height: 150px;
        @include flex();
        flex-direction: column;
      }
      .item{
        width: 150px;
        height: 150px;
        background: #F5F5F7;
        border-radius: 16px;
        text-align: center;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .icon-add{
          font-size: 24px;
          color: $base-color;
        }
        .txt{
          display: inline-block;
          font-size: 14px;
          color: #999;
          margin-top: 6px;
        }
      }
      .img-list{
        img{
          width: 150px;
          height: 150px;
          border-radius: 16px;
        }
        .img-box{
          position: relative;
          .iconfont{
            font-size: 28px;
            color: #222;
            position: absolute;
            right: 2px;
            top: 2px;
            z-index: 2;
          }
        }
      }
    }
    .input-group{
      margin-top: 10px;
      .input-row{
        margin-bottom: 10px;
      }
      .row{
        height: 40px;
        @include flex-align();
        margin-bottom: 5px;
        .label-name{
          width: 88px;
          height: 40px;
          line-height: 40px;
          display: inline-block;
          margin-right: 5px;
          font-size: 15px;
          color: #222;
          text-align: left;
        }
      }
      /deep/ input, .validity-box{
        height: 40px;
        // margin-bottom: 5px;
        border-radius: 10px;
        // border-radius: 10px 0 0 10px;
        // border: 1px solid #ddd;
        font-size: 16px;
        color: #222;
        span{
          // width: 100%;
          height: 40px;
          line-height: 40px;
          padding: 0 .75rem;
          display: inline-block;
          font-size: 16px;
        }
        .date-time{
          width: 320px;
          color: #222;
        }
        .date-placeholder{
          width:100%;
          display: inline-block;
          color: #ccc;
        }
      }
      .col-valid-disable{
        width:250px;background:#f5f5f5;border-radius:10px 0 0 10px;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: 16px;
        color: #ccc;
        font-weight: 400;
      }
      .validity-box, .pc-validity-box{
        width: 100%;
      }
      /deep/ .is-disabled{
      .el-input__inner{
          border-radius: 10px 0 0 10px !important;
        }
      }
    }
  }
  .validity-box, .pc-validity-box{
    border: .05rem solid #DCDFE6;
  }
  .pc-validity-box{
    border-radius:10px;
    /deep/ .el-input__inner{
      border: 0;
    }
  }
  .validity-box, .pc-validity-box{
    position: relative;
    /deep/ .el-checkbox{
      width: 80px;
      height: 40px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
      color: #47B6C7;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background: #47B6C7;
      border-color: #47B6C7;
    }
  }
  .pc-validity-box{
    height: 40px;
    /deep/ .el-checkbox__input, /deep/ .el-checkbox__inner{
      width: 16px;
      height: 16px;
    }
    /deep/ .el-checkbox__inner::after{
      height: 12px;
      left: 5px;
    }
    /deep/ .el-checkbox__label{
      line-height: 1;
      font-size: 14px;
    }
    /deep/ .el-input__inner{
      margin-bottom: 0;
    }
  }
  .radio-group-section{
    width: 334px;
    height: 60px;
    margin-bottom: 13px;
    /deep/ .van-radio__icon{
      font-size: 0.6rem !important;
    }
    .radio-group{
      height: 60px;
      .van-radio-group{
        height: 60px;
        .van-radio{
          font-size: 16px;
          color: #222;
          &:first-child{
            margin-right: 36px;
          }
        }
      }
    }
  }
  .bank-select-box{
    width: 333px;
    height: 40px;
    /deep/ .el-input{
      height: 40px;
    }
    /deep/  .el-input__inner{
      height: 40px;
      border-radius: 10px;
      border: 1px solid #DDDDDD;
      font-size: 16px;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder {
      font-size: 16px;
      color: #ccc;
      font-weight: 400;
    }
  }
  .supplement-section{
    .upload-item{
      /deep/ .img-box{
        margin-bottom: 20px;
      }
    }
  }
  .agreement-section{
    padding: 12px 16px;
    background: #F5F5F7;
    border-radius: 16px;
    box-sizing: border-box;
    @include flex();
    .iconfont{
      font-size: 20px;
      cursor: pointer;
    }
    .icon-a-noSelected{
      color: #ccc;
    }
    .icon-agree{
      color: $base-color;
    }
    .agreement-info{
      line-height: 1.5;
      margin-left: 12px;
      font-size: 14px;
      color: #0A1629;
      cursor: pointer;
      a{
        font-size: 14px;
        color: #0A1629;
      }
      .licence{
        font-size: 14px;
        color: $base-color;
      }
    }
  }

  .agreement-modal{
    width: 334px;
    margin: 0 auto;
    padding-top: 1px;
    padding-bottom: 15px;
    .m-header{
      width: 334px;
      margin: 0 auto;
      h3{
        font-size: 16px;
        color: #222;
        margin: 15px 0;
      }
    }
    .m-body{
      width: 334px;
      max-height: 450px;
      margin: 0 auto;
      overflow-y: auto;
      overflow-x: hidden;
      p{
        line-height: 1.5;
        font-size: 14px;
        color: #333;
        margin-bottom: 12px;
      }
    }
  }
  .error-msg{
    font-size: 13px;
    color: #FF4743;
  }
  .footer-bar{
    height: 100px;
    // display: block;
  }
  .footer{
    position: inherit;
    bottom: 0;
    padding: 20px 0 30px;
    .btn-group{
      width: 324px;
      .jump-btn{
        width: 60px;
        font-size: 16px;
        color: #47B6C7;
        text-align: right;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/baseinfo-auth.vue